import { ImportLogStore } from './importLogs-Store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new ImportLogStore());
}
